import { getUOMConversionString } from "c8-platform";
import Controller from "csi/action/Controller";
import locale from "csi/locale";
import siteDefaultLocale from "csi/siteDefaultLocale";
import { C8Node } from "csi/typings";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

/**
 * DeleteUOMCustomAttribute uses the same logic as DeleteCustomAttribute.js but instead
 * applies the logic to both attributes in the UOM attribute duo to delete both attributes in one action.
 */
const DeleteUOMCustomAttribute = declare(Controller, {

	/** @property {C8Node} _uomValueAttr - Value attribute node */
	_uomValueAttr: null,

	/** @property {C8Node} _conversionTypeField - Conversion attribute node */
	_uomConversionAttr: null,

	/** @property {String} uomNameResource - Localized resource for UnitOfMeasure.Name */
	uomNameResource: null,

	/** @property {String} caNameResource - Localized resource for ConfigurableAttribute.Plural */
	caNameResource: null,

	/**
     * @override
     * Find UOM Conversion custom attribute
     */
	onStart(): void {
		const node = this.getNode();
		this._uomValueAttr = node;
		this._uomConversionAttr = this.getCache().getNode(getUOMConversionString(node.$URL));
	},

	/**
     * @override
     * Confirmation message to delete UOM value and conversion custom attributes
     */
	confirmAction(params): void {
		params.message = locale.resource("DeleteUOMCustomAttribute_ConfirmationDialog", [this._uomValueAttr.$Name, this._uomConversionAttr.$Name]);
		this.inherited(arguments);
	},

	/**
     * @override
     * Delete UOM value and conversion attributes
     */
	toWriter(): void {
		// In order to update LocaleConfiguration.Types when deleting the
		// custom attribute, first empty localization fields
		this.toWriterLocale(this._uomValueAttr);
		this.toWriterLocale(this._uomConversionAttr);

		this.inherited(arguments);

		this.m_writer.callMethod("SiteAdmin", "RemoveEntriesFromUOMModuleCreateLists")
			.addParameter("AttributeName", xml.ATTR_STRING, this._uomValueAttr.$Name)
			.addParameter("ReflectionAttributeOwner", xml.ATTR_STRING, this._uomValueAttr.ReflectionAttributeOwner);
		this.m_writer.callMethod("Reflection", "DeleteCustomAttribute")
			.addParameter("URL", xml.ATTR_CNL, this._uomValueAttr.$URL);
		this.m_writer.callMethod("Reflection", "DeleteCustomAttribute")
			.addParameter("URL", xml.ATTR_CNL, this._uomConversionAttr.$URL);
	},

	/** 
	 * @override
	 * Refresh data after deleting UOM attribute duo
	 */
	postProcessSuccess(): void {
		this.inherited(arguments);
		this.widget.refreshData();
	},

	toWriterLocale(nodeCA: C8Node): void {
		if (nodeCA) {
			const id = siteDefaultLocale.getConfigurableAttributeId(nodeCA);
			const typeClass = siteDefaultLocale.getConfigurableAttributeType(nodeCA);

			const	w = this.m_writer;

			// In order to delete custom attribute localization from LocaleConfiguration.types, empty the value
			// First check whether the attribute localization exists
			if (siteDefaultLocale.getTypeAttributeResource(typeClass, id)){
				siteDefaultLocale.setResource(w, siteDefaultLocale.ATTR_TYPES, [typeClass, siteDefaultLocale.TYPE_ATTR, id], "", null, true);
			}

			if (siteDefaultLocale.getTypeAttributeResource(typeClass, id+siteDefaultLocale.TOOLTIP)){
				siteDefaultLocale.setResource(w, siteDefaultLocale.ATTR_TYPES, [typeClass, siteDefaultLocale.TYPE_ATTR, id+siteDefaultLocale.TOOLTIP], "", null, true);
			}

			if (siteDefaultLocale.getTypeAttributeResource(typeClass, id+siteDefaultLocale.ATTR_VALIDATION)){
				siteDefaultLocale.setResource(w, siteDefaultLocale.ATTR_TYPES, [typeClass, siteDefaultLocale.TYPE_ATTR, id+siteDefaultLocale.ATTR_VALIDATION], "", null, true);
			}
		}
	},

});

export = DeleteUOMCustomAttribute;